// Purpose-built square kebab: web-common's DotsVertical has a 3×13 aspect that distorts (dots
// smear into wide ovals) when forced into a square icon box.
export function KebabIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="4" r="1.7" fill="currentColor" />
      <circle cx="9" cy="9" r="1.7" fill="currentColor" />
      <circle cx="9" cy="14" r="1.7" fill="currentColor" />
    </svg>
  );
}
